/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Form from "../../../components/Form";
import Modal, { ModalHeader } from "../../../components/Modal";
import useForm from "../../../hooks/useForm";
import systemAlert from "../../../utils/systemAlert";
import { NOTICE } from "../../../constants/COMMUNITY";
import { getFormatDateHour, hasInRange } from "../../../utils/date";
import Comment from "../../../components/Comment";
import { addTaxConsultingPost, editTaxConsultingPost } from "../../../apis/tax-portal/tax-consulting";
// import useForm from "../../../hooks/useForm";

const DetailTaxConsultingPost = (props) => {
  const { currentBoard, post, open, setOpen, setPost, submit, permission = 5, orgMode } = props;

  const [mode, setMode] = useState(orgMode);
  const [fields, setFields] = useState([]);
  const [buttons, setButtons] = useState([]);
  const [isCanEdit] = useState(false);
  const defaultForm = {
    title: "",// 제목
    content: "", // 내용
    isNotice: "0",
    fileIdxes: []
  };

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    resetForm(defaultForm);
    setPost(null);
  };

  const _submit = ({
    isNotice,
    ..._form
  }) => {
    const form = {
      ..._form,
      isNotice: isNotice === "1",
    };

    if (mode === "create") {
      systemAlert(`"${form.title}" 등록하시겠습니까?`, {

        buttons: [
          {
            color: "text",
            label: "취소"
          },
          {
            label: "등록",
            onClick: () => {
              addTaxConsultingPost({
                boardIdx: currentBoard.idx,
                ...form
              })
                .then(() => {
                  cancel();
                  if (submit) {
                    submit();
                  }
                });
            }
          }
        ]
      });
    } else if (mode === "modify") {
      systemAlert(`"${form.title}" 수정하시겠습니까?`, {

        buttons: [
          {
            color: "text",
            label: "취소"
          },
          {
            label: "수정",
            onClick: () => {
              editTaxConsultingPost(post.idx, form)
                .then(() => {
                  cancel();
                  if (submit) {
                    submit();
                  }
                });
            }
          }
        ]
      });
    }
  };

  const {
    form,
    errors,
    handleSubmit,
    handleOnChange,
    setForm,
    resetForm,
    setOriginForm,
    setValidateFields
  } = useForm(
    defaultForm,
    _submit
  );

  useEffect(() => {
    setMode(orgMode);
    if (post) {
      const form = {
        ...post,
        isNotice: post.isNotice ? "1" : "0",
        fileIdxes: post.uploadFiles
      };
      setForm(form);
      setOriginForm(form);
    } else {
      setForm({
        ...defaultForm,
      });
      setOriginForm({
        ...defaultForm,
      });
    }
  }, [open, post, orgMode]);

  useEffect(() => {
    setFields([
      [
        {
          isHide: mode === "view" || permission.level <= 2,
          title: "공지사항",
          key: "isNotice",
          type: "radio",
          options: {
            list: NOTICE,
          },
          required: true,
        },

      ],
      [
        {
          isHide: mode !== "view",
          title: mode !== "view" && "작성자", key: "employee.name",
          className: "mt-10"
        },
        {
          isHide: mode !== "view",
          title: mode !== "view" && "작성일시", key: "createdTime",
          className: "text-align-right color-gray-5",
          onValue: (data, fields, datas) => {
            return `작성일 : ${getFormatDateHour(data)} `;
          }
        },
      ],
      {
        isHide: mode !== "view",
        type: "line"
      },
      [
        {
          isHide: () => {
            return mode === "view";
          },
          title: "제목",
          key: "title",
          type: "input",
          required: true,
          readOnly: mode === "modify" ? true : false
        },
      ],
      [
        {
          className: "min-heihgt-200",
          title: mode !== "view" && "내용",
          key: "content",
          type: "editor",
          isHide: () => {
            return !currentBoard?.useOptions?.content;
          },
        },
      ],
      {
        isHide: () => mode !== "view" || !currentBoard?.useOptions?.content,
        type: "line"
      },
      [
        {
          title: "첨부파일",
          key: "fileIdxes",
          type: "dropzone",
          isHide: () => !currentBoard?.useOptions?.file
        },
      ],
      {
        isHide: mode !== "view",
        type: "reaction",
        params: {
          postIdx: "idx",
          postType: "tax_consulting"
        },
        fullWidth: true
      },
    ]);

  }, [mode, currentBoard]);

  useEffect(() => {
    setButtons([
      {
        color: "text",
        label: "닫기",
        onClick: cancel
      },
      {
        isHide: mode !== "modify",
        label: "수정",
        onClick: handleSubmit
      },
      {
        isHide: mode !== "create",
        label: "글쓰기",
        onClick: () => {
          handleSubmit();
        }
      }
    ]);
  }, [mode, isCanEdit]);
  useEffect(() => {
    setValidateFields(fields);
  }, [fields]);

  return (
    <Modal
      isOpen={open}
      close={cancel}
    >
      <div className="client-write">
        <ModalHeader>{post ? <>{post.isNotice && hasInRange(post.topStartTime, post.topEndTime) ? "[공지] " : ""}{post.title}</> : "글쓰기"} </ModalHeader>
        {post && post.isNotice ? <div>
        </div> : <></>}
        <Form
          mode={mode}
          form={form}
          errors={errors}
          isRequiredShow={true}
          setForm={setForm}
          fields={fields}
          onChange={handleOnChange}
          buttons={buttons}
        >
          {mode === "view" && post && currentBoard?.useOptions?.comment && (
            <div className="file-upload-list">
              <div className="file-upload-form">
                <Comment
                  postIdx={post.idx}
                  postType="tax_consulting"
                  submit={submit}
                  isFirstSubmit={false}
                  param={{ title: post.title }}
                />
              </div>
            </div>
          )}
        </Form>

      </div>
    </Modal>
  );
};

export default DetailTaxConsultingPost;
